import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { SubscriptionsState, SUBSCRIPTIONS_SLICE_NAME } from './models';

export const subscriptionsSelector = (state: RootState): SubscriptionsState => state[SUBSCRIPTIONS_SLICE_NAME];

export const selectSubscriptionsIsLoading = createSelector(
  subscriptionsSelector,
  (state: SubscriptionsState) => state.isLoading,
);

export const selectQuery = createSelector(subscriptionsSelector, (state: SubscriptionsState) => state.query);
